import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const CREATE_OFFER_MUTATION = gql`
  mutation createQuote(
    $title: String,
    $customerId: String,
    $contactPersonId: String,
    $objektId: String,
    $properties: [CustomPropertyInputArbonia]
  ) {
    createQuote(
      title: $title,
      customerId: $customerId,
      contactPersonId: $contactPersonId,
      objectId: $objektId,
      properties: $properties
    ) {
      documentId
      revision
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateOfferMutation extends Mutation<RootMutation> {
  document = CREATE_OFFER_MUTATION;
}
